import React from 'react';
import { Link } from 'react-router-dom';

export interface Page {
  label: string;
  url: string;
}

interface BreadcrumbProps {
  pages: Page[];
}

export default function Breadcrumb({ pages }: BreadcrumbProps) {
  return (
    <ol className='breadcrumb h-my-0'>
      {pages.map((page, index) => (
        <li key={index} className='breadcrumb-item active'>
          {page.url === '' ? (
            <span>{page.label}</span>
          ) : (
            <Link to={page.url} className='breadcrumb-item'>
              {page.label}
            </Link>
          )}
        </li>
      ))}
    </ol>
  );
}
